<template>
  <div ref="map" :class="[tureCountry === 'USA'? 'map scaleUSA': tureCountry === 'NorthEarth' ? 'map scaleNorth' : 'map scaleCanada',showRotateTips ? 'hosMap':'']" style="position: relative">
    <svg
      id="svgMap"
      width="100%"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      style="overflow: hidden; position: relative;"
      :viewBox="viewBox"
      preserveAspectRatio="xMidYMin meet"
    >
      <desc style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
        Created with Rapha?l 2.1.2
      </desc>
      <defs style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);"></defs>
      <rect
        x="-800"
        y="-800"
        width="4000"
        height="2400"
        r="0"
        rx="0"
        ry="0"
        fill="#ffffff"
        stroke="none"
        style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 0;"
        fill-opacity="0"
      ></rect>
      <path
        v-for="item in mapArr"
        :key="item.id"       
        :fill="item.key ? 'rgb(3,118,239)' : 'rgb(206,230,255)'"
        stroke="#ffffff"
        :d="item.d"
        transform="matrix(0.8,0,0,0.8,16,8)"
        stroke-width="2"
        stroke-opacity="1"
        stroke-linejoin="round"
      ></path>
      <g v-if='showTips'>
        <polygon 
          :points="polygonPath"
          :x="textInfo.x"
          :y="textInfo.y"
          transform="matrix(0.8,0,0,0.8,10.5,11)"
          style="fill: #fff;"
          stroke='#0032717a'/>
        <!-- svg插入图片 -->
        <defs>
          <pattern id="raduisImage" patternUnits="objectBoundingBox" width="60" height="60" x='0' y ='0'>
            <image 
              x='0' y ='0'
              :xlink:href='url'
              width="60" 
              height="60"
            />
          </pattern>
        </defs>
        <circle 
          :cx="this.textInfo.x + 35" 
          :cy="this.textInfo.y + 30" 
          r="30" 
          fill="url(#raduisImage)" 
          transform="matrix(0.8,0,0,0.8,-40,-62)"></circle>

        <!-- 手动转成圆形图片插入 -->
        <!-- <image 
          :x="textInfo.x"
          :y="textInfo.y"
          transform="matrix(0.8,0,0,0.8,-40,-62)"
          :xlink:href="imageToCricle(url)"
          width="60" height="60"/> -->
        <text
          :x="textInfo.x"
          :y="textInfo.y"
          transform="matrix(0.8,0,0,0.8,36,-36)"
          text-anchor="middle"
          font='10px "Arial"'
          stroke="none"
          fill="#000"
          fill-opacity="1"
          font-size="30px"
          font-weight="bold"
          stroke-width="1.25"
        >
          <tspan dy="7.765625" style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0); no-repeat center center;" class="driverImg">
            {{ textInfo.text }}
          </tspan>
        </text>
      </g>
    </svg>
  </div>
</template>

<script>
import Canada from '../static/Canada.js'
import USA from '../static/USA.js'
import NorthEarth from '../static/USACanada.js'
import { caculateData } from '../static/stateCaculate.js'

export default {
  name:'year-review-map',
  props: ['tureCountry', 'states', 'changePotraitState','url','showRotateTips'],
  data() {
    return {
      polygonPath: '',
      // url: require('@/assets/images/tp-logo.png'),
      mapArr: [],
      x: 0,
      y: 0,
      timer: null,
      viewBox: "0 0 800 600",
      caculateState: {},
      textInfo: {
        x: 0,
        y: 0,
        text: ''
      },
      showTips: false,
      serviceDate: [],
    }
  },
  created() {
    this.serviceDate = this.states;
  },
  mounted() {
    this.initMap()
  },
  watch:{
    states(val){
      if(this.states.length){
        this.serviceDate = this.states
        // console.log(this.serviceDate,'..serviceDate')
        this.lightUpState()
      }
    }
  },
  destroyed(){
    clearTimeout(this.timer)
  },

  methods: {
    initMap(){
      this.mapArr = this.tureCountry === 'USA' ? USA : this.tureCountry === 'Canada' ? Canada : NorthEarth 
      this.viewBox = this.tureCountry === 'USA' ? "0 -40 800 600" : this.tureCountry === 'Canada' ? "-25 0 850 750" : "100 0 800 650" 
      // this.lightUpState()
    },
    getPosition(param, text){
      if(!param){
        return;
      }
      let newArr = param.substr(1, param.length-1).replace(/(M|ZM|Z|MZ)/g, 'L').split('L');
      let xArr = [];
      let yArr = [];
      newArr.forEach(item => {
        let itemArr = item.split(',');
        if(itemArr[0]){
          xArr.push(Number(itemArr[0].substr(0, 6)));
        }
        if(itemArr[1]){
          yArr.push(Number(itemArr[1].substr(0, 6)));
        }
      });

      let xMax = Math.max.apply(null, xArr);
      let xMin = Math.min.apply(null, xArr);
      let yMin = Math.min.apply(null, yArr);

      let obj = {
        x: Number(((xMax + xMin)/2).toFixed(2)),
        y: Number(yMin),
      }
      return obj;
    },
    lightUpState(){
      this.serviceDate.forEach((item) => {
        if(caculateData.indexOf(item) > -1){
          this.caculateState[caculateData.indexOf(item)] = item;	
        }
      })
      this.serviceDate = Object.values(this.caculateState)
      this.serviceDate.forEach((item,i)=>{
        this.timer = setTimeout(()=>{
          if(this.mapArr[item]){
            let position = this.getPosition(this.mapArr[item].d, item);
            this.mapArr[item]['key'] = true;
            this.textInfo.x = position.x;
            this.textInfo.y = position.y + 10;
            this.textInfo.text = item;
            this.polygonPath = `${position.x} ${position.y},${Number(position.x)-15} ${position.y-15},${Number(position.x)-75} ${position.y-15},${Number(position.x)-75} ${position.y-90},${Number(position.x)+75} ${position.y-90},${Number(position.x)+75} ${position.y-15},${Number(position.x)+15} ${position.y-15}`;
            this.showTips = true;
          }
          if(i >= this.serviceDate.length - 1){
            setTimeout(() => {
              this.showTips = false;
              this.changePotraitState();
            }, 1000);
          }
        }, 1000*i);
      })
      // let stop = null
      // this.count++
      // stop = window.requestAnimationFrame(this.lightUpState)
      // if(this.count === this.serviceDate.length){
      //   this.count = 0
      //   window.cancelAnimationFrame(stop);
      // }
      // this.mapArr[this.serviceDate[this.count]]['key'] = true
    },
    imageToCricle(img) {
      if (typeof img !== 'object') {
        var tem = new Image();
        tem.src = img;
        img = tem;
      }
      var w, h, _canv, _contex, cli;
      if (img.width > img.height) {
        w = img.height;
        h = img.height;
      } else {
        w = img.width;
        h = img.width;
      }
      _canv = document.createElement('canvas');
      _canv.width = w;
      _canv.height = h;
      _contex = _canv.getContext("2d");
      cli = {
        x: w / 2,
        y: h / 2,
        r: w / 2
      };
      _contex.clearRect(0, 0, w, h);
      _contex.save();
      _contex.beginPath();
      _contex.arc(cli.x, cli.y, cli.r, 0, Math.PI * 2, false);
      _contex.clip();
      _contex.drawImage(img, 0, 0);
      _contex.restore();
      return _canv.toDataURL();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/rem.scss';
$rem: 66.7px;
html{
  font-size: $rem;
}
@function remHos($px) {
  @return $px / $rem * 1rem;
}
.map{
  padding: 0 rem(25px);
  box-sizing: border-box;
  margin-top: 0;
}
path {
  cursor: pointer;
  stroke-opacity: 1;
  stroke-linejoin: round;
}
text {
  text-anchor: middle;
  fill-opacity: 1;
  cursor: pointer;
}
.scaleUSA{
  // transform: scale(1.1);
  // margin-bottom: rem(21px);
}
.scaleNorth{
  transform: scale(1)
}
.scaleCanada{
  margin-top: rem(-30px);
  transform: scale(1)
}
.driverImg{
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: url('http://img3.imgtn.bdimg.com/it/u=3118956596,1809570833&fm=26&gp=0.jpg') no-repeat center center;
}

.hosMap{
  padding: 0 remHos(25px);
  .scaleCanada{
    margin-top: remHos(-30px);
  }
}

// iphone x xr 11 的设备比所在区域
  @media screen and (min-aspect-ratio: 414 / 740) and (max-aspect-ratio: 414 / 700){
  }
  
  @media screen and (min-aspect-ratio: 414 / 700) and (max-aspect-ratio: 414 / 660){
  }

  @media screen and (min-aspect-ratio: 414 / 660) and (max-aspect-ratio: 414 / 620){
    .scaleCanada{
      margin-top: rem(-40px);
    }
  }
  // iphone 6 7 8 所在区域
  @media screen and (min-aspect-ratio: 414 / 620) and (max-aspect-ratio: 414 / 600){
    .scaleCanada{
      margin-top: rem(-40px);
    }
  }
  
  @media screen and (min-aspect-ratio: 414 / 600) and (max-aspect-ratio: 414 / 580){
    .scaleCanada{
      margin-top: rem(-45px);
    }
    .scaleUSA{
      margin-top: rem(-20px);
    }
  }
  
  @media screen and (min-aspect-ratio: 414 / 580) and (max-aspect-ratio: 414 / 550){
    .scaleCanada{
      margin-top: rem(-45px);
    }
    .scaleUSA{
      margin-top: rem(-30px);
    }
  }
  
  @media screen and (min-aspect-ratio: 414 / 550) and (max-aspect-ratio: 414 / 520){
    .scaleCanada{
      margin-top: rem(-45px);
    }
    .scaleUSA{
      margin-top: rem(-35px);
    }
  }

  // ipad 横屏
  // @media screen and (min-aspect-ratio: 414 / 414) and (max-aspect-ratio: 414 / 100){
  //   .scaleCanada{
  //     transform: scale(0.8);
  //     margin-top: rem(-80px);
  //   }
  //   .scaleUSA{
  //     margin-top: rem(-50px);
  //   }
  // }
</style>
